import Resources from './resources';

export default function ({ dispatch, showAction, hideAction }) {
    const env = Resources.env;

    function requestInterceptor() {
        dispatch(showAction());
    }

    function responseInterceptor(response) {
        const hasPendingRequest = env.havePendingRequests();
        const action = hasPendingRequest ? showAction() : hideAction();

        dispatch(action);

        return response;
    }

    if (env) {
        env.addRequestInterceptor(requestInterceptor);
        env.addResponseInterceptor(responseInterceptor);
    }
}



// WEBPACK FOOTER //
// ./helpers/busy-indicator-interceptor.js